import { Suspense } from "react"
import { makeStyles } from "tss-react/mui"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { StandardDialog } from "../../../../../shared/components/dialogs/StandardDialog"
import { QueryErrorBoundary } from "../../../../../core/api/components/QueryErrorBoundary"
import { UserDetailsContent } from "./UserDetailsContent"
import { DataLoader } from "./UserDetailsDataLoader"

const useStyles = makeStyles()(() => ({
}))

export type UserDetailsDialogProps = Readonly<{
    open: boolean
    onClose: () => void
    userId: number
    userType: "user" | "admin"
    title?: string
}>

export function UserDetailsDialog({ open, onClose, userId, userType, title }: UserDetailsDialogProps) {
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()

    return (
        <StandardDialog
            dialogTitle={title !== undefined ? title : l10n.getString("office-manager-user-details-dialog-title")}
            open={open}
            onClose={onClose}
            maxWidthProp="md"
            scroll="body"
        >
            <QueryErrorBoundary>
                <Suspense fallback={<UserDetailsContent user={undefined} />}>
                    <DataLoader userId={userId} userType={userType} />
                </Suspense>
            </QueryErrorBoundary>
        </StandardDialog>
    )
}
